<template>
  <v-card width="500" class="mx-auto" style="margin: 10%">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-card-title>
        <div>Login</div>
      </v-card-title>
      <v-card-text class="mt-5">
        <v-form>
          <validation-provider rules="email|required" name="email" v-slot="{ errors }">
            <v-text-field
              @keyup.enter="doLogin"
              :error-messages="errors"
              name="email"
              v-model="userName"
              label="Username"
              prepend-icon="mdi-account-circle"
              outlined
              dense
            />
          </validation-provider>

          <validation-provider rules="min:8|max:16|required" name="email" v-slot="{ errors }">
            <v-text-field
              @keyup.enter="doLogin"
              :error-messages="errors"
              v-model="password"
              label="Password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
            />
          </validation-provider>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="doLogin"
          :disabled="loading || invalid"
          :loading="loading"
          color="info"
          width="100"
        >
          Login
        </v-btn>
      </v-card-actions>
    </validation-observer>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { extend } from 'vee-validate';
import { required, min, max, email } from 'vee-validate/dist/rules';

extend('required', { ...required, message: 'field is required' });
extend('min', { ...min, message: 'should be at least {length} characters' });
extend('max', { ...max, message: 'max characters length exceeded: {length}' });
extend('email', { ...email, message: 'Invalid email address' });
extend('password', {
  params: ['target'],
  validate: (value, { target }) => value === target,
  message: 'Password confirmation does not match'
});

export default {
  data() {
    return {
      userName: '',
      password: '',
      showPassword: false
    };
  },
  computed: {
    ...mapState('auth', ['loading'])
  },
  methods: {
    doLogin() {
      this.$store.dispatch('auth/login', {
        username: this.userName,
        password: this.password
      });
    }
  }
};
</script>